<template>
    <div class="container py-60">
        <div class="box-shadow pt-30 pb-40" v-if="emailLinkData">
            <div class="row justify-content-center">
                <div class="col-10">
                    <h1>Thank you!</h1>
                    <p>{{ emailLinkData }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'RenewTrip',
        data() {
            return {
                message: '',
                emailLinkData: ''
            }
        },
        computed: {
            hash() {
                return this.$route.params.hash
            }
        },
        mounted() {
            if (this.hash) {
                this.fetchEmailLinkData()
            }
        },
        methods: {
            fetchEmailLinkData() {
                axios
                    .get(`/api/renew-trip/${this.hash}`)
                    .then(res => {
                        this.emailLinkData = res.data
                    })
                    .catch(() => {
                        //this.$router.replace({path: '/'})
                    });
            }
        }
    }
</script>
